import React, { useState } from 'react';
import InviteRelativesForm from './InviteRelativesForm';

function InviteRelativeAction() {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };


  const handleInvite = () => {
    closeModal(); // Close the modal after handling the invite logic
  };

  const handleCancel = () => {
    console.log('Cancel button clicked');
    closeModal(); // Close the modal after handling the cancel logic
  };

  const handleInputChange = (e) => {
    //onInputChange(e); // Use the onInputChange function from props
    console.log("I am here....")
  };


  return (
    <div>
    <button onClick={openModal}>Invite Relatives</button>

      <InviteRelativesForm
        isOpen={isModalOpen}
        onClose={closeModal}
        onInvite={handleInvite}
        onCancel={handleCancel}
      />
      </div>
  );
}

export default InviteRelativeAction;
